import React from 'react';
import { ArrowRight, Shield } from 'lucide-react';
import { Link } from 'react-router-dom';

const PolitiqueConfidentialite = () => {
  return (
    <div className="min-h-screen pt-32 pb-20 bg-gradient-to-b from-gray-50 to-white">
      {/* Page Header */}
      <section className="relative text-white py-20 mb-16" style={{
        background: 'linear-gradient(135deg, #0A2463 0%, #0D2F7E 50%, #1035A0 100%)'
      }}>
        <div className="container mx-auto px-4 text-center relative z-10">
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 bg-brand-gold rounded-full flex items-center justify-center">
              <Shield size={40} className="text-white" />
            </div>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{
            textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
          }}>
            Politique de <span style={{ 
              background: 'linear-gradient(to bottom, #f9a01b 0%, #ffd230 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>Confidentialité</span>
          </h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed mt-6">
            Protection de vos données personnelles (RGPD)
          </p>
        </div>
      </section>

      {/* Content */}
      <div className="container mx-auto px-4 max-w-4xl">
        {/* Introduction */}
        <section className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-8">
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2463' }}>
            <span style={{ 
              background: 'linear-gradient(to bottom, #f9a01b 0%, #ffd230 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>Introduction</span>
          </h2>
          
          <div className="space-y-4 text-gray-700 leading-relaxed">
            <p>
              Chez <strong>Chango's Renovation</strong>, nous accordons une grande importance à la protection de votre vie privée et de vos données personnelles. Cette politique de confidentialité vous informe sur la manière dont nous collectons, utilisons et protégeons vos informations personnelles conformément au Règlement Général sur la Protection des Données (RGPD).
            </p>
            <p>
              <strong>Responsable du traitement des données :</strong><br />
              Chango's Renovation<br />
              Brusselstraat 189, 1702 Dilbeek, Belgique<br />
              Email : <a href="mailto:changos.renovation@gmail.com" className="text-brand-gold hover:underline">changos.renovation@gmail.com</a><br />
              Tél : <a href="tel:0471664418" className="text-brand-gold hover:underline">0471 66 44 18</a>
            </p>
          </div>
        </section>

        {/* Données collectées */}
        <section className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-8">
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2463' }}>
            Données <span style={{ 
              background: 'linear-gradient(to bottom, #f9a01b 0%, #ffd230 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>Collectées</span>
          </h2>
          
          <div className="space-y-4 text-gray-700 leading-relaxed">
            <p>Nous collectons les données personnelles suivantes lorsque vous utilisez nos formulaires de contact ou de demande de devis :</p>
            
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Identité :</strong> Nom, prénom</li>
              <li><strong>Contact :</strong> Adresse email, numéro de téléphone</li>
              <li><strong>Projet :</strong> Type de projet, délai souhaité, budget estimatif, détails du projet</li>
            </ul>

            <p className="mt-4">
              Ces données sont collectées <strong>uniquement</strong> lorsque vous les fournissez volontairement via nos formulaires de contact.
            </p>
          </div>
        </section>

        {/* Finalités */}
        <section className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-8">
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2463' }}>
            Utilisation de vos <span style={{ 
              background: 'linear-gradient(to bottom, #f9a01b 0%, #ffd230 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>Données</span>
          </h2>
          
          <div className="space-y-4 text-gray-700 leading-relaxed">
            <p>Vos données personnelles sont utilisées pour les finalités suivantes :</p>
            
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Répondre à vos demandes :</strong> Traiter vos demandes de contact ou de devis</li>
              <li><strong>Gestion commerciale :</strong> Établir des devis, suivre les projets</li>
              <li><strong>Communication :</strong> Vous contacter pour discuter de votre projet</li>
              <li><strong>Amélioration du service :</strong> Analyser nos services pour mieux vous servir</li>
            </ul>

            <p className="mt-4">
              <strong>Base légale :</strong> Le traitement de vos données repose sur votre consentement et sur l'exécution de mesures précontractuelles prises à votre demande.
            </p>
          </div>
        </section>

        {/* Conservation */}
        <section className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-8">
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2463' }}>
            Conservation des <span style={{ 
              background: 'linear-gradient(to bottom, #f9a01b 0%, #ffd230 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>Données</span>
          </h2>
          
          <div className="space-y-4 text-gray-700 leading-relaxed">
            <p>Vos données personnelles sont conservées pendant les durées suivantes :</p>
            
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Demandes de contact/devis non abouties :</strong> 3 ans maximum</li>
              <li><strong>Clients :</strong> Pendant la durée de la relation commerciale + 10 ans (obligations légales et garanties)</li>
            </ul>

            <p className="mt-4">
              Au-delà de ces durées, vos données seront supprimées ou anonymisées.
            </p>
          </div>
        </section>

        {/* Droits */}
        <section className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-8">
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2463' }}>
            Vos <span style={{ 
              background: 'linear-gradient(to bottom, #f9a01b 0%, #ffd230 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>Droits</span>
          </h2>
          
          <div className="space-y-4 text-gray-700 leading-relaxed">
            <p>Conformément au RGPD, vous disposez des droits suivants :</p>
            
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Droit d'accès :</strong> Obtenir une copie de vos données personnelles</li>
              <li><strong>Droit de rectification :</strong> Corriger vos données inexactes ou incomplètes</li>
              <li><strong>Droit à l'effacement :</strong> Demander la suppression de vos données</li>
              <li><strong>Droit à la limitation :</strong> Limiter le traitement de vos données</li>
              <li><strong>Droit d'opposition :</strong> Vous opposer au traitement de vos données</li>
              <li><strong>Droit à la portabilité :</strong> Recevoir vos données dans un format structuré</li>
            </ul>

            <p className="mt-4">
              <strong>Pour exercer vos droits :</strong><br />
              Envoyez un email à <a href="mailto:changos.renovation@gmail.com" className="text-brand-gold hover:underline font-semibold">changos.renovation@gmail.com</a> avec votre demande. Nous vous répondrons dans un délai d'un mois.
            </p>

            <p className="mt-4">
              Vous avez également le droit d'introduire une réclamation auprès de l'Autorité de Protection des Données (APD) belge : <a href="https://www.autoriteprotectiondonnees.be" target="_blank" rel="noopener noreferrer" className="text-brand-gold hover:underline">www.autoriteprotectiondonnees.be</a>
            </p>
          </div>
        </section>

        {/* Sécurité */}
        <section className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-8">
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2463' }}>
            Sécurité des <span style={{ 
              background: 'linear-gradient(to bottom, #f9a01b 0%, #ffd230 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>Données</span>
          </h2>
          
          <div className="space-y-4 text-gray-700 leading-relaxed">
            <p>
              Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre toute destruction accidentelle ou illicite, perte accidentelle, altération, diffusion ou accès non autorisé.
            </p>
            <p>
              Vos données sont hébergées sur des serveurs sécurisés et ne sont accessibles qu'au personnel autorisé.
            </p>
          </div>
        </section>

        {/* Partage des données */}
        <section className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-8">
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2463' }}>
            Partage des <span style={{ 
              background: 'linear-gradient(to bottom, #f9a01b 0%, #ffd230 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>Données</span>
          </h2>
          
          <div className="space-y-4 text-gray-700 leading-relaxed">
            <p>
              Nous ne vendons, ne louons ni ne partageons vos données personnelles avec des tiers à des fins commerciales.
            </p>
            <p>
              Vos données peuvent être partagées uniquement avec :
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Nos prestataires techniques (hébergement, maintenance) dans le cadre strict de leurs missions</li>
              <li>Les autorités légales si requis par la loi</li>
            </ul>
          </div>
        </section>

        {/* Cookies */}
        <section className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-8">
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2463' }}>
            <span style={{ 
              background: 'linear-gradient(to bottom, #f9a01b 0%, #ffd230 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>Cookies</span>
          </h2>
          
          <div className="space-y-4 text-gray-700 leading-relaxed">
            <p>
              Notre site utilise uniquement des cookies strictement nécessaires au fonctionnement du site (cookies techniques). Aucun cookie de tracking ou publicitaire n'est utilisé.
            </p>
          </div>
        </section>

        {/* Mise à jour */}
        <section className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-8">
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2463' }}>
            Mise à Jour de cette <span style={{ 
              background: 'linear-gradient(to bottom, #f9a01b 0%, #ffd230 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>Politique</span>
          </h2>
          
          <div className="space-y-4 text-gray-700 leading-relaxed">
            <p>
              Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. Toute modification sera publiée sur cette page avec indication de la date de mise à jour.
            </p>
            <p>
              <strong>Dernière mise à jour :</strong> Mars 2025
            </p>
          </div>
        </section>

        {/* CTA */}
        <section className="mt-12">
          <div className="rounded-2xl p-8 md:p-12 text-center" style={{
            background: 'linear-gradient(135deg, #0A2463 0%, #0D2F7E 50%, #1035A0 100%)'
          }}>
            <h2 className="text-3xl font-bold text-white mb-4">
              Des Questions sur vos Données ?
            </h2>
            <p className="text-xl text-white/90 mb-8">
              Contactez-nous pour toute question relative à la protection de vos données personnelles
            </p>
            <Link 
              to="/contact" 
              className="inline-flex items-center justify-center gap-2 bg-brand-gold text-gray-900 px-8 py-4 rounded-xl font-bold text-lg hover:bg-brand-gold-light transition-all hover:shadow-xl hover:scale-105"
            >
              Nous Contacter
              <ArrowRight size={20} />
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
};

export default PolitiqueConfidentialite;
